import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { getThemeConfig } from '../externals';
import { useTooltipBehavior } from '../shared';
import { TooltipPane, TooltipPointerSpace, TooltipWrapper } from '../styles';

var Tooltip = function Tooltip(_ref) {
  var dataTest = _ref['data-test'],
      children = _ref.children,
      className = _ref.className,
      open = _ref.open,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottomRight' : _ref$position,
      targetElement = _ref.targetElement,
      theme = _ref.theme,
      onTooltipShown = _ref.onTooltipShown;

  var _useTooltipBehavior = useTooltipBehavior(targetElement, open, onTooltipShown),
      extendedTargetElement = _useTooltipBehavior.extendedTargetElement,
      id = _useTooltipBehavior.id,
      isTooltipShown = _useTooltipBehavior.isTooltipShown,
      onMouseLeaveWrapper = _useTooltipBehavior.onMouseLeaveWrapper,
      wrapperRef = _useTooltipBehavior.wrapperRef;

  var componentTheme = useComponentTheme({
    name: 'Tooltip',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(TooltipWrapper, {
    className: className,
    "data-test": dataTest ? "".concat(dataTest, "-wrapper") : undefined,
    onMouseLeave: onMouseLeaveWrapper,
    ref: wrapperRef
  }, extendedTargetElement, /*#__PURE__*/React.createElement(TooltipPane, {
    customTheme: componentTheme,
    "data-test": dataTest ? dataTest : undefined,
    id: id,
    isShown: isTooltipShown,
    position: position,
    role: "tooltip"
  }, children, /*#__PURE__*/React.createElement(TooltipPointerSpace, {
    position: position
  })));
};

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/tooltip/dist/esm/variants/Tooltip.js
// module id = 4542
// module chunks = 11